// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2CE1U","inputWrap":"Table_inputWrap__1WzRx","col":"Table_col__2Z9_F","bmiTooltip":"Table_bmiTooltip__FRpDl"};